import { type Ref, type CSSProperties, type FC } from "react"

import { cn } from "../utilities/tailwind"

type Props = { html: string; ref?: Ref<HTMLDivElement>; className?: string; style?: CSSProperties }
const LexicalViewer: FC<Props> = ({ html, ref, className, style }) => {
	return (
		<div ref={ref} dangerouslySetInnerHTML={{ __html: html }} className={cn("lexical", className)} style={style} />
	)
}

export default LexicalViewer
